
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[insuranceType]/quote",
      function () {
        return require("private-next-pages/[insuranceType]/quote/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[insuranceType]/quote"])
      });
    }
  